import { ColDef } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { useAbsoluteTimePartialColDef } from '@casops/components/tables/cells/absolute-time/useAbsoluteTime';
import { DeviceMessageModel } from '@casops/store/apis/deviceMessagesApi';
import {
  DeviceMessageStatusCellRenderer,
  deviceMessageStatusValueGetter,
} from '@casops/components/tables/cells/device-message-status/DeviceMessageStatusCellRenderer';
import { deviceMessageSourceValueGetter } from '@casops/components/tables/cells/device-message-source/DeviceMessageSourceCellRenderer';

type Model = DeviceMessageModel;

export function useDeviceMessagesColumnDefs(showDevice: boolean): ColDef<Model>[] {
  const { t } = useTranslation();

  const absoluteTimeColDef = useAbsoluteTimePartialColDef<Model>();

  return useMemo<ColDef<Model>[]>(() => {
    const columnDefs: ColDef<Model>[] = [
      { field: 'tsCre', headerName: t('Fields.DateAndTime'), minWidth: 120, ...absoluteTimeColDef },
      {
        field: 'src',
        headerName: t('Fields.Source'),
        width: 120,
        valueGetter: deviceMessageSourceValueGetter,
      },
    ];

    if (showDevice) {
      columnDefs.push({ field: 'did', headerName: t('Fields.TargetDevice'), minWidth: 120 });
    }

    columnDefs.push({ field: 'typ', headerName: t('Fields.MessageType'), minWidth: 120 });

    columnDefs.push({
      field: 'tsUpd',
      headerName: t('Fields.LatestUpdate'),
      minWidth: 120,
      ...absoluteTimeColDef,
    });

    columnDefs.push({
      field: 'sts',
      headerName: t('Fields.MessageStatus'),
      minWidth: 120,
      valueGetter: deviceMessageStatusValueGetter,
      cellRenderer: DeviceMessageStatusCellRenderer,
    });

    return columnDefs;
  }, [absoluteTimeColDef, showDevice, t]);
}
